import React, { forwardRef } from "react";
import "./Stack.css";

/* Stack — flex layout primitive. Replace MUI <Box display="flex"> usage. */
export const Stack = forwardRef(function Stack(
  {
    direction = "column",
    gap = 4,
    align,
    justify,
    wrap = false,
    inline = false,
    as = "div",
    className = "",
    style,
    children,
    ...props
  },
  ref
) {
  const Component = as;
  const cssGap = typeof gap === "number" ? `var(--sp-${gap})` : gap;
  return (
    <Component
      ref={ref}
      className={`ui-stack ${inline ? "ui-stack-inline" : ""} ${className}`}
      style={{
        flexDirection: direction,
        gap: cssGap,
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap ? "wrap" : "nowrap",
        ...style,
      }}
      {...props}
    >
      {children}
    </Component>
  );
});

/* Cluster — horizontal stack with sensible defaults. */
export function Cluster(props) {
  return <Stack direction="row" align="center" wrap {...props} />;
}

/* Spacer — pushes flex siblings apart. */
export function Spacer({ className = "", ...props }) {
  return <div className={`ui-spacer ${className}`} {...props} />;
}
